var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoblue = function SvgLogoblue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#27AAE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7651FF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)",
    fillRule: "evenodd",
    transform: "translate(-83 -40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.257 57c0 9.192 7.432 16.644 16.6 16.644 6.145 0 11.505-3.349 14.376-8.323l-10.27-5.945a4.74 4.74 0 0 1-4.105 2.38A4.75 4.75 0 0 1 95.115 57a4.75 4.75 0 0 1 4.743-4.755V40.356c-9.169 0-16.601 7.452-16.601 16.644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.083 52.804 5.568-10.5a16.5 16.5 0 0 0-7.793-1.948v11.889a4.7 4.7 0 0 1 2.225.559",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.962 54.624 10.27-5.945a16.7 16.7 0 0 0-2.042-2.812l-8.811 7.955c.22.246.417.514.583.802",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.378 53.822 8.812-7.955a16.7 16.7 0 0 0-4.539-3.562l-5.568 10.499c.49.262.927.607 1.295 1.018",
    opacity: 0.4
  }))));
};
export default SvgLogoblue;